<template>
  <div class="mobile">
    <component :is="template"></component>
  </div>
</template>

<script>
import { STORE_KEY, LOCAL_SAVE_EXERCISE_CLASS } from './_store/constants'
import { STORE_KEY as STORE_KEY_QUESTION } from '@/modules/question/preview-question/_store/constants'
import store from './_store'
import storeQuestion from '@/modules/question/preview-question/_store'
import ExerciseQuestionDetail from './_views/ExerciseQuestionDetail'
import ExerciseExamDetail from './_views/ExerciseExamDetail'
import QuestionTopic from './_views/QuestionTopic'
import QuestionGuide from './_views/QuestionGuide'

export default {
  name: 'ExerciseModule',
  props: {
    template: String
  },
  components: {
    ExerciseQuestionDetail,
    ExerciseExamDetail,
    QuestionTopic,
    QuestionGuide
  },
  created () {
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }

    if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY_QUESTION, storeQuestion)
    }
  },
  beforeDestroy () {
    localStorage.removeItem(LOCAL_SAVE_EXERCISE_CLASS)
  }
}
</script>